import { UUID } from "../../../infrastructure/ui/shared/types";

interface Answer {
  readonly id: string;
  readonly key: string;
}

enum QuestionType {
  GIVEN_ANSWER = "GIVEN_ANSWER",
  COMMENT = "COMMENT",
}

class Question {
  id: string;
  key: string;
  type: QuestionType;
  answers: Answer[];

  constructor({ id, key, type, answers }: { id: UUID; key: string; type: QuestionType; answers: Answer[] }) {
    this.id = id;
    this.key = key;
    this.type = type;
    this.answers = answers || [];
  }
}

export type { Answer };
export { Question, QuestionType };
